import { EventSlot } from "../../events/EventSlot";

export interface EventListenerClass<E>
{
  add( element:Element, callback:(e:E)=>void ):void
  remove( element:Element, callback:(e:E)=>void ):void
} 

export enum EventListenerCacheRemovalType
{
  CUSTOM,
  EVENT_SLOT,
  EVENT_LISTENER  
}

export class EventListenerCacheEntry
{
  listenerCallback:( a?:any ) => void ;
  removalType:EventListenerCacheRemovalType
  target:any;  
  eventListenerType:EventListenerClass<any>;
  customRemoval:( a?:any )=>void;

  remove()
  {
    switch ( this.removalType )
    {
      case EventListenerCacheRemovalType.EVENT_SLOT: 
      {
        this.removeEventSlot();
      }
      break;

      case EventListenerCacheRemovalType.EVENT_LISTENER: 
      {
        this.removeEventListener();
      }
      break;

      case EventListenerCacheRemovalType.CUSTOM: 
      {
        this.customRemoval();
      }
      break;
    }
  }

  removeEventSlot()
  {
    ( this.target as EventSlot<any> ).removeListener( this.listenerCallback );
  }

  removeEventListener()
  {
    this.eventListenerType.remove( this.target as Element, this.listenerCallback );
  }
}


export class EventListenerCache
{
  #entries:EventListenerCacheEntry[] = [];

  remove()
  {
    this.#entries.forEach( e => e.remove() );
    this.#entries = [];
  }


  onSlot<T>( target:EventSlot<T>, callback:(t?:T)=>void )
  {
    let entry = new EventListenerCacheEntry();

    entry.removalType = EventListenerCacheRemovalType.EVENT_SLOT;    
    entry.target = target;
    entry.listenerCallback = callback;

    target.addListener( callback );

    this.#entries.push( entry );
  }

  onListener<E>( type:EventListenerClass<E>, target:Element, callback:(e:E)=>void )
  {
    let entry = new EventListenerCacheEntry();

    entry.removalType = EventListenerCacheRemovalType.EVENT_LISTENER;    
    entry.target = target;
    entry.listenerCallback = callback;
    entry.eventListenerType = type;

    type.add( target, callback );

    this.#entries.push( entry );
  }

  addCustomRemoval( removal:(a?:any)=>void )
  {
    let entry = new EventListenerCacheEntry();

    entry.removalType = EventListenerCacheRemovalType.CUSTOM;    
    entry.customRemoval = removal;

    this.#entries.push( entry );
  }
}